var AuthType = /* @__PURE__ */ ((AuthType2) => {
  AuthType2["NONE"] = "none";
  AuthType2["BASIC"] = "basic";
  AuthType2["SESSION_TOKEN"] = "session-token";
  AuthType2["ACCESS_TOKEN_URL"] = "access-token-url";
  AuthType2["ACCESS_TOKEN_DATA"] = "access-token-data";
  AuthType2["CONSUMER"] = "consumer";
  AuthType2["SSO_TOKEN"] = "sso-token";
  return AuthType2;
})(AuthType || {});
function resolveOption(param, axiosRequestConfig) {
  return typeof param === "function" ? param(axiosRequestConfig) : param;
}

export { AuthType, resolveOption };
//# sourceMappingURL=utils.js.map
